import { Formattable } from 'visuris/Data/Entities/Formattable';
import { formatCoordinate, formatDate } from 'visuris/Data/Formatters';
import * as i18n from 'CMS/core/i18n';
import SearchResultGisInformation from './SearchResultGisInformation';

export default class RisIndex extends Formattable {

    public isrs: string = null;
    public countryCode: string = null;
    public unloCode: string = null;
    public fairwayCode: string = null;
    public objectCode: string = null;
    public hectom: string = null;
    public risFunction: string = null;
    public objectName: string = null;
    public nationalObjectName: string = null;
    public locationName: string = null;
    public fairwayName: string = null;
    public nationalFairwayName: string = null;
    public routeName: string = null;
    public lat: number = null;
    public lon: number = null;
    public source: string = null;
    public positionCode: string = null;
    public section: string = null;
    public relatedISRS: string = null;

    //full
    public relatedENCs: string = null;
    public communicationInformation: string = null;
    public natGaugeCode: string = null;
    public vesselConvoyLength: number = null;
    public vesselConvoyBreadth: number = null;
    public vesselConvoyDraught: number = null;
    public vesselConvoyAirDraught: number = null;
    public availableLength: number = null;
    public clearanceWidth: number = null;
    public availableDepthCode: string = null;
    public availableDepthValue: number = null;
    public clearanceHeightCode: string = null;
    public clearanceHeightValue: number = null;
    public gaugeISRS: string = null;
    public applicabilityFromKm: number = null;
    public applicabilityToKm: number = null;
    public refL1Code: string = null;
    public refL2Code: string = null;
    public refL3Code: string = null;
    public refL1Value: number = null;
    public refL2Value: number = null;
    public refL3Value: number = null;
    public zeroPointCm: number = null;
    public geodRef: string = null;
    public categoryOfTimeSchedule: string = null;
    public forShipType: string = null;
    public forUseOfShip: string = null;
    public linkToExternalXmlFileTimeSchedule: string = null;
    public linkToExternalXmlFilePassageTime: string = null;
    public vesselConvoyLength2: number = null;
    public vesselConvoyBreadth2: number = null;
    public vesselConvoyDraught2: number = null;
    public vesselConvoyAirDraught2: number = null;
    public availableLength2: number = null;
    public clearanceWidth2: number = null;
    public availableDepthCode2: string = null;
    public availableDepthValue2: number = null;
    public clearanceHeightCode2: string = null;
    public clearanceHeightValue2: number = null;
    public gaugeISRS2: string = null;
    public vesselConvoyLength3: number = null;
    public vesselConvoyBreadth3: number = null;
    public vesselConvoyDraught3: number = null;
    public vesselConvoyAirDraught3: number = null;
    public availableLength3: number = null;
    public clearanceWidth3: number = null;
    public availableDepthCode3: string = null;
    public availableDepthValue3: number = null;
    public clearanceHeightCode3: string = null;
    public clearanceHeightValue3: number = null;
    public gaugeISRS3: string = null;
    public categoryOfTimeSchedule2: string = null;
    public forShipType2: string = null;
    public forUseOfShip2: string = null;
    public linkToExternalXmlFileTimeSchedule2: string = null;
    public linkToExternalXmlFilePassageTime2: string = null;
    public categoryOfTimeSchedule3: string = null;
    public forShipType3: string = null;
    public forUseOfShip3: string = null;
    public linkToExternalXmlFileTimeSchedule3: string = null;
    public linkToExternalXmlFilePassageTime3: string = null;
    public dateBegLoc: Date = null;
    public dateEndLoc: Date = null;
    public dateInfo: Date = null;
    public reason: string = null;
    public function: string = null;
    public relatedObjectName: string = null;
    public gaugeObjectName: string = null;
    public searchPriority: number = null;
    public isFavorited: boolean = null;

    //refdata
    public functionMessage: string = null;
    public countryCodeMessage: string = null;
    public positionCodeMessage: string = null;
    public refL1CodeMessage: string = null;
    public refL2CodeMessage: string = null;
    public refL3CodeMessage: string = null;
    public geodRefMessage: string = null;
    public availableDepthCodeMessage: string = null;
    public clearanceHeightCodeMessage: string = null;
    public translatedFairwayName: string = null;

    //gisinfo
    public gisInfo: SearchResultGisInformation = null;

    constructor() {
        super();
    }

    protected getFormatters(): any {
        return {
            "isrs": () => { return this.isrs},
            "lat": () => { return formatCoordinate(this.lat); },
            "lon": () => { return formatCoordinate(this.lon); },
            "fullFairwayName": () => { return this.fairwayCode + ' ' + this.fairwayName; },
            "fairwayName": () => { return this.fairwayName; },
            "dateBegLoc": () => { return formatDate(this.dateBegLoc); },
            "dateEndLoc": () => { return formatDate(this.dateEndLoc); },
            "dateInfo": () => { return formatDate(this.dateInfo); },
            "function": () => { return this.functionMessage; },
            "country": () => { return this.countryCodeMessage; },
            "objectName": () => { return this.objectName; },
            "source": () => { return this.source; }
        };
    }

}